import React from "react"
import ReactDOM from "react-dom"
import CovidTableContainer from "./covid-table-container-component"

export default class CovidTableContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<CovidTableContainer {...self.modelJson} />, self.elem)
  }
}
